import defaultLocale from './default';
import * as moment from 'moment';
moment.locale('en');
export default defaultLocale;



// WEBPACK FOOTER //
// ./components/locale-provider/en_US.tsx